export enum MyHistoryScreen {
  chapters,
  chapter,
  stories,
  friendChapters,
  friendChapter,
  friendStories,
  friendsOfFriends,
  allFriendStories
}
